<template>
<v-container style="position:relative;top:100px;z-index:98">
<v-row  v-if="items.length > 1">
    <v-col cols="12" >
        <v-breadcrumbs :items="items" large>
            <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
            </template>
        </v-breadcrumbs>
    </v-col>
</v-row>
</v-container>
</template>

<script>
import {i18n} from "@/main";
export default {
    data: () => ({
        items: [{
            disabled: false,
            text: i18n.t('HOME'),
            to: '/'
        }]
    }),
    methods: {
        getItems() {
            if (this.$route.fullPath !== '/') {

                let routes = this.$route.fullPath.split('/');
                let curRoute = '';
                this.items = [{
                    disabled: false,
                    link: true,
                    text: i18n.t('HOME'),
                    to: '/'
                }];
                for (let i = 1; i < routes.length; i++) {
                    curRoute += '/' + routes[i];
                    this.items.push({
                        disabled: (i === routes.length - 1),
                        link: true,
                        text: i18n.t(routes[i]),
                        href: curRoute
                    })
                }
 
            } else this.items = [];
            let idx = this.items.findIndex(e => (e.text === 'category'));
            if (idx != -1)
                this.items.splice(idx, 1)
            idx = this.items.findIndex(e => (e.text === 'products'));
            if (idx != -1)
                this.items.splice(idx, 1)
        }
    },
    watch: {
        $route: function () {
            this.items = [{
            disabled: false,
            link: true,
            text: i18n.t('HOME'),
            to: '/'
        }];
            this.getItems();
        }
    },
    mounted() {
        this.getItems();
    }
}
</script>

<style scoped>
ul{
    padding-left: 0 !important;
}
</style>